import BaseService from './BaseService';

export default class extends BaseService {
  static index(options = {}) {
    const url = super.url('service_requests');

    if (options.page) {
      url.searchParams.append('service_requests', options.page);
    }

    return super
      .get(url)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        return Promise.reject(error.response.data);
      });
  }

  static getServiceRequests(pageNo = 1, resultList = [], extraParams = '') {
    let url = super.url("service_requests") + `?page[number]=${pageNo}&page[size]=${100}&${extraParams}`
    return super.get(url).then(response => {
      if (response.data.serviceRequests.length > 0) {
        resultList = resultList.concat(response.data.serviceRequests)
        return this.getServiceRequests(pageNo+1, resultList, extraParams)
      } else {
        return Promise.resolve(resultList)
      }
    }).catch(error => {
      console.log(error)
      return Promise.reject(error)
    })
  }

  static getServiceRequestsInArea({sw, ne}) {
    const extraParams = `bbox[sw]=${sw.lat},${sw.lng}&bbox[ne]=${ne.lat},${ne.lng}`;
    return this.getServiceRequests(1, [], extraParams);
  }
  
  static getServiceRequestsByName(query) {
    const url = `${super.url('service_requests')}?q=${query}&paginate=false`;
    return super.get(url);
  }
}
